var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { TemplateService } from "~/services/domain-service/template.service";
var SendMessage = /** @class */ (function (_super) {
    __extends(SendMessage, _super);
    function SendMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overduePeriod = "";
        _this.templateDataSet = [];
        _this.rules = {
            templateId: [{ required: true, message: "请输入模板名称" }]
        };
        _this.contactModel = {
            personalContactId: "",
            relationship: "",
            targetName: "",
            mobileNo: ""
        };
        _this.model = {
            templateId: "",
            templateContent: ""
        };
        return _this;
    }
    SendMessage.prototype.refresh = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.resetFields();
        this.caseOperatorPageService.queryCaseInfo(this.caseId).subscribe(function (data) {
            _this.overduePeriod = "N" + data.overduePeriod;
        });
    };
    SendMessage.prototype.close = function () {
    };
    SendMessage.prototype.onOverduePeriod = function (val) {
        var _this = this;
        if (!val) {
            this.templateDataSet = [];
            return;
        }
        var overduePeriod = "";
        if (val && Number.parseInt(val.substr(1)) >= 37) {
            overduePeriod = "N37";
        }
        var request = {
            // overduePeriod: val && Number.parseInt(val.substr(1)) >= 37 ? 'N37' : val,
            templateCategory: "MESSAGE"
        };
        this.templateService
            .getTemplateByOverduePeriod(request)
            .subscribe(function (data) { return (_this.templateDataSet = data || []); });
    };
    SendMessage.prototype.onTemplateContentChange = function (templateId) {
        var _this = this;
        this.caseOperatorPageService
            .getTemplateContent({ caseId: this.caseId, templateId: templateId })
            .subscribe(function (data) { return (_this.model.templateContent = data); });
    };
    SendMessage.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (result) {
            if (!result)
                return;
            var request = {
                caseId: _this.caseId,
                templateId: _this.model.templateId,
                contIds: [_this.contactsData.id]
            };
            _this.caseOperatorPageService.sendMessage(request).subscribe(function (data) {
                _this.$message.success("发送成功!");
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], SendMessage.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], SendMessage.prototype, "templateService", void 0);
    __decorate([
        Prop({ required: true })
    ], SendMessage.prototype, "caseId", void 0);
    __decorate([
        Prop({ required: true })
    ], SendMessage.prototype, "contactsData", void 0);
    __decorate([
        Emit("close")
    ], SendMessage.prototype, "close", null);
    __decorate([
        Watch("overduePeriod")
    ], SendMessage.prototype, "onOverduePeriod", null);
    SendMessage = __decorate([
        Component({})
    ], SendMessage);
    return SendMessage;
}(Vue));
export default SendMessage;
